import { FC } from 'react';
import ConnectionConversionList from './conectionConversionList';
import React from 'react';
import { useDispatch } from 'react-redux';
import { loadConnectionConversions } from './conectionConversionSlice';
import { CommonContext, CommonContextType } from '../../contexts/CommonContext';
import { Modal } from 'antd';
import AddConnectionConversion from './addConnectionConversion';

const ConnectionConversionPage: FC = () => {
    const dispatch = useDispatch();
    const { isModalOpen, setModelChange, contextHolder, setEditBodySize, editBodySize } = React.useContext(CommonContext) as CommonContextType;

    const showModal = () => {
        setModelChange(true);
    };
    const handleCancel = () => {
        setEditBodySize(null)
        setModelChange(false);
    };
    React.useEffect(() => {
        dispatch(loadConnectionConversions());
    }, [dispatch]);
    return (
        <div className='padding' style={{ background: '#ffffff' }}>
            {contextHolder}
            <br></br>
            <h2>Connection Conversions List
            <button className='top-button' onClick={showModal}>Create</button>
            </h2>
            <ConnectionConversionList />
            <Modal title={editBodySize?.id ? 'Edit Data' : 'Create Data'} open={isModalOpen} onCancel={handleCancel} maskClosable={false} footer={null}>
                <AddConnectionConversion />
            </Modal>
        </div>
    );

};

export default ConnectionConversionPage;